/**
 * web-content app preset — one layer of the shared-styles theme cascade
 * (base tokens -> app preset -> instance default -> tenant override).
 *
 * EAA-1664: web-content's base palette (packages/shared-styles/src/colors.ts)
 * already *is* this app's default look post Phase 1, so this preset is
 * intentionally an empty, sparse override — it exists to prove the app-preset
 * layer wires end-to-end (imported by `applyTheme()`'s cascade) without
 * introducing a visual diff. A future app with a different default look adds
 * its overrides here, following the same shape as `theme.instance.json`.
 */
import type { CustomThemeConfig } from '@ai-content-hub/shared-styles';

export const webContentThemePreset: CustomThemeConfig = {
    light: {},
    dark: {},
};
